import { ReactElement, useMemo, memo } from 'react';
import { useTheme, Typography, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen as StopsIcon } from '@fortawesome/free-solid-svg-icons';

import MultipleLinearProgresBar from '~components/MultipleLinearProgresBar';

import { StopsProgressInfoProps } from './types';
import { StopsProgressInfoContainer, StopsProgressInfoIcon } from './styles';

const StopsProgressInfo = ({
  total,
  pendings,
  completedSuccess,
  completedFails,
  withoutVisiting,
  fontSize = 14,
  enabledIcon = false,
}: StopsProgressInfoProps): ReactElement => {
  const currentTheme = useTheme();

  const finalizedCount = useMemo(
    () => completedSuccess + completedFails + withoutVisiting,
    [completedSuccess, completedFails, withoutVisiting],
  );

  return (
    <StopsProgressInfoContainer size={fontSize}>
      {enabledIcon && (
        <StopsProgressInfoIcon size={fontSize}>
          <FontAwesomeIcon icon={StopsIcon} />
        </StopsProgressInfoIcon>
      )}

      <Box flex={1}>
        <MultipleLinearProgresBar
          items={[
            {
              label: 'Cumplidos',
              value: completedSuccess,
              color: currentTheme.palette.success.main,
            },
            {
              label: 'Con incidencias',
              value: completedFails,
              color: currentTheme.palette.error.main,
            },
            {
              label: 'Cierre forzoso',
              value: withoutVisiting,
              color: currentTheme.palette.warning.main,
            },
            {
              label: 'Pendientes',
              value: pendings,
              color: currentTheme.palette.grey[400],
            },
          ]}
          max={total}
          size="xSmall"
          showLegend={false}
          showTotal={false}
          enabledTooltip
        />
      </Box>

      <Typography variant="inherit" component="span">
        {`${finalizedCount} de ${total}`}
      </Typography>
    </StopsProgressInfoContainer>
  );
};

export default memo(StopsProgressInfo);
